<template>
  <div class="topBar">
    <v-toolbar color="rgb(236,236,236)" elevation="0" flat dense fixed>
      <div class="sim-info">
        <span class="sim-name">
          {{ simName }}
        </span>
        <span class="automation-name">
          {{ automationName }}
        </span>
      </div>
      <v-spacer></v-spacer>

      <v-tooltip v-if="playIcon == 'Play'" bottom open-delay="500" color="#5774E7">
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="mx-1 pa-1" v-bind="attrs" v-on="on" ref="playButton" @click="$emit('pressedButton', 'pressedPlay')" elevation="0" height="32px" width="32px" x-small color="white"><v-img src="../assets/icons/playicon.svg" /></v-btn>
        </template>
        <span>Play the simulation</span>
      </v-tooltip>

      <v-tooltip v-else bottom open-delay="500" color="#5774E7">
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="mx-1 pa-1" v-bind="attrs" v-on="on" ref="pauseButton" @click="$emit('pressedButton', 'pressedPlay')" elevation="0" height="32px" width="32px" x-small color="white"><v-img src="../assets/icons/pauseicon.svg" /></v-btn>
        </template>
        <span>Pause the simulation</span>
      </v-tooltip>

      <v-tooltip bottom open-delay="500" color="#5774E7">
        <template v-slot:activator="{ on, attrs }">
        <div v-on="on">
          <v-btn class="mx-1 pa-1" v-bind="attrs" @click="$emit('pressedButton', 'pressedHome')" elevation="0" height="32px" width="32px" :disabled="showHomeButton" x-small color="white"><v-img src="../assets/icons/home.svg" /></v-btn>
        </div>
        </template>
        <span>Reset the viewport</span>
      </v-tooltip>

      <v-tooltip bottom open-delay="500" color="#5774E7">
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="mx-1 pa-1" @click="changeSpeed" v-bind="attrs" v-on="on" elevation="0" height="32px" width="32px" x-small color="white"
            ><span class="times-sign">x</span><span class="speed-number">{{ timesSpeedMapper[$store.state.speedIndex] }}</span></v-btn
          >
        </template>
        <span>Increase the speed of the simulation (use shift/ctrl to decrease)</span>
      </v-tooltip>

      <v-tooltip bottom open-delay="500" color="#5774E7">
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="mx-1 pa-1 ml-5" v-bind="attrs" v-on="on" @click="$emit('pressedButton', 'pressedReset')" elevation="0" height="32px" width="32px" dark x-small color="white"><v-img src="../assets/icons/refresh.svg" /></v-btn>
        </template>
        <span>Reset the simulation</span>
      </v-tooltip>

      <v-tooltip bottom open-delay="500" color="#5774E7">
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="mx-1 pa-2" v-bind="attrs" v-on="on" @click="$emit('pressedButton', 'pressedNewSimulation')" elevation="0" height="32px" width="32px" x-small color="white"><v-img src="../assets/icons/Union.svg" /></v-btn>
        </template>
        <span>Create a new simulation</span>
      </v-tooltip>
<!-- 
      <v-tooltip v-if="showFutureloadGraph" bottom open-delay="500" color="#5774E7">
        <template  v-slot:activator="{ on, attrs }">
          <v-btn class="mx-1 pa-1 debugButton" v-bind="attrs" v-on="on" @click="$emit('pressedButton', 'pressedRefresh')" elevation="0" height="32px" width="32px" x-small color="white"><v-img src="../assets/sidebar/graphs.svg" /></v-btn>
        </template>
        <span>Manually refresh the futureload graph</span>
      </v-tooltip> -->

      <!-- <v-tooltip v-if="showFutureloadGraph" bottom open-delay="500" color="#5774E7">
          
          <template>
          
            </template>
            
          <span>Save the portfolio settings</span>
      </v-tooltip> -->

      <PortfolioSave v-if="showFutureloadGraph"/>
      <AdminSimulate v-if="$store.state.isAdmin && canSimulate()"/>
        

      <!-- <v-tooltip bottom open-delay="500" color="#5774E7">
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="mx-1 pa-1 debugButton" v-bind="attrs" v-on="on" @click="$emit('pressedButton', 'pressedDebug')" elevation="0" height="32px" width="32px" x-small color="white"><v-img src="../assets/icons/home.svg" /></v-btn>
        </template>
        <span>Debug button</span>
      </v-tooltip> -->

      <v-spacer></v-spacer>
      <span></span>
      <!-- <v-btn class="mx-2" @click="$emit('pressedButton', 'pressedPause')" style="margin: 0" elevation="0" fab dark x-small color="rgb(240, 240, 240)"><v-icon large color="red">mdi-pause</v-icon></v-btn> -->
      <!-- <v-btn class="mx-2" @click="$emit('pressedButton', 'pressedStep')" style="margin: 0" elevation="0" fab dark x-small color="rgb(240, 240, 240)"><v-icon large color="grey">mdi-arrow-expand-right</v-icon></v-btn> -->
      <!-- <v-btn class="mx-2" @click="$emit('pressedButton', 'pressedSort')" style="margin: 0" elevation="0" fab dark x-small color="rgb(240, 240, 240)"><v-icon large color="grey">mdi-sort</v-icon></v-btn> -->
      <!-- <v-btn class="mx-2" @click="$emit('pressedButton', 'pressedDebug')" style="margin: 0" elevation="0" fab dark x-small color="rgb(240, 240, 240)"><v-icon large color="grey">mdi-message</v-icon></v-btn> -->
      <!-- <v-btn class="mx-2" @click="$emit('pressedButton', 'pressedSimulate')" style="margin: 0" elevation="0" fab dark x-small color="rgb(240, 240, 240)"><v-icon large color="grey">mdi-alert</v-icon></v-btn> -->
      <!-- <v-btn class="mx-2" @click="$emit('pressedButton', 'pressedRequest')" style="margin: 0" elevation="0" fab dark x-small color="rgb(240, 240, 240)"><v-icon large color="grey">mdi-laptop</v-icon></v-btn> -->

      <div class="timePassedContainer">
        <span class="day-span"> Day </span>
        <span class="day-spent-span"> {{ this.timeString }} / {{ endTimeString }} </span>
      </div>
    </v-toolbar>
  </div>
</template>
<script>
// eslint-disable-next-line no-unused-vars
import PortfolioSave from "./PortfolioSave"
import AdminSimulate from "./AdminSimulate"

export default {
  components: {
    PortfolioSave,
    AdminSimulate,
  },
  name: "SimulatorTopBar",
  data: () => ({
    simName: "",
    automationName: "",
    items: ["Foo", "Bar", "Fizz", "Buzz"],
    timesSpeedMapper: [1, 2, 4, 8, 16, 32, 64],
    timeString: "0.0",
    endTimeString: "0.0",
    playIcon: "Play",
    openPortfolioDialog: false,
    showHomeButton: true,
    showFutureloadGraph: false,
  }),
  mounted: function () {
    this.$store.state.topBar = this;
    this.updatePlayButton();
  },
  methods: {
    canSimulate(){
      if(this.$store.state.simulator == null){
        return false;
      }

      return !this.$store.state.simulator.params.isManual;
    },
    updatePlayButton() {
      if (!this.$store.state.manuallyPaused) {
        this.playIcon = "Pause";
      } else {
        this.playIcon = "Play";
      }
    },
    changeSpeed(e) {
      var offset = 1;
      if (e.shiftKey || e.ctrlKey) {
        offset = -1;
      }
      this.$store.state.speedIndex = (this.$store.state.speedIndex + offset + this.timesSpeedMapper.length) % this.timesSpeedMapper.length;
      this.$store.state.visualiser.params.setDurationSpeed(this.timesSpeedMapper[this.$store.state.speedIndex]);
    },
    getSpeedValue() {
      return this.timesSpeedMapper[this.$store.state.speedIndex];
    },
    updateTimePassedString(hoursPassed) {
      var daysPassed = Math.floor(hoursPassed / 8);
      var remainingHours = hoursPassed - daysPassed * 8;

      this.timeString = `${daysPassed}.${remainingHours}`;

      this.endTimeString = `${this.$store.state.simulator.params.simulationMaxDurationDays}` + ".0";
    },
    updateSimInfo(simulator) {
      this.showFutureloadGraph = simulator.params.allowPortfolioPlanning;
      this.simName = simulator.params.simulationName + ":";
      this.automationName = simulator.automationMethod;
    },
  },
};
</script>

<style scoped>
.day-span {
  color: #808080;
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 20px;
}
.day-spent-span {
  color: #4a4a4a;
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 20px;
}
.v-btn {
  border: 1px solid #abb8f8 !important;
}

.times-sign {
  padding-left: 2px;
  padding-top: 2px;
  margin: 0;
  color: #5774e7;
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 1000;
  font-size: 11px;
  line-height: 20px;
}

.speed-number {
  color: #5774e7;
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 20px;
}
.timePassedContainer {
  height: 100%;

  white-space: nowrap;
  overflow: hidden;
  padding: 7px;
  font-size: 1.5em;
}

.timePassed {
  width: 100%;
  height: 100%;
  text-align: right;
}

.topBar {
  display: flex;
  height: 48px;
  z-index: 1;
  outline: rgb(220,220,220) solid 1px;
}

i {
  width: 100%;
  height: 100%;
  font-size: 330px;
}
button {
  height: var(--simulation-button-height);
  width: var(--simulation-button-height);

  border: none;
  border-radius: 20%;
  background-color: var(--background-color);
}

v-btn:hover {
  background-color: rgb(118, 118, 118);
}

.simulatorButtons {
  padding: 0;
  margin: 0;
  width: 50%;
  height: var(--simulation-button-height);
  background-color: var(--background-color);
  text-align: left;
}

.sim-info {
  position: absolute;
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 24px;
  /* identical to box height, or 150% */

  text-align: center;

  /* Grey / 600 */
}

.portfolioSave{
  width: 100px;
  height: 100px;
}

span.sim-name {
  color: #4a4a4a;
}

span.automation-name {
  color: #808080;
}
</style>
